import { DateTime } from "luxon";

//  Fields accepted by the GraphQL PaymentInput / CardInput / NetworkInput
//  types (see packages/auth-ms/src/schemas/account.js).
//
//  Stripe periodically adds new properties to its token and card objects
//  (wallet, regulated_status, display_brand, allow_redisplay, networks.available
//  ...). GraphQL input objects are strict: an undeclared property makes variable
//  coercion fail with HTTP 400 before any resolver runs, which Apollo surfaces
//  to the user as "Network error: Response not successful: Received status code
//  400". Building the payload from these allowlists instead of deleting known
//  extras keeps checkout working when Stripe adds the next field.
const STRIPE_TOKEN_FIELDS = [
  "card",
  "client_ip",
  "created",
  "email",
  "id",
  "livemode",
  "object",
  "type",
  "used"
];
const STRIPE_CARD_FIELDS = [
  "address_city",
  "address_country",
  "address_line1",
  "address_line1_check",
  "address_line2",
  "address_state",
  "address_zip",
  "address_zip_check",
  "brand",
  "country",
  "cvc_check",
  "dynamic_last4",
  "exp_month",
  "exp_year",
  "funding",
  "id",
  "last4",
  "metadata",
  "name",
  "networks",
  "object",
  "regulated_status",
  "tokenization_method"
];
const STRIPE_CARD_NETWORK_FIELDS = ["preferred"];

const pickFields = (source, fields) =>
  fields.reduce((picked, field) => {
    if (Object.prototype.hasOwnProperty.call(source, field)) {
      picked[field] = source[field];
    }
    return picked;
  }, {});

export default {
  formatDateToTime(date) {
    if (date) {
      const dt = DateTime.fromISO(date);

      return dt.toFormat("h:mm a");
    } else {
      return null;
    }
  },
  formatTime(time) {
    if (time) {
      const dt = DateTime.fromFormat(`01-01-2000 ${time}`, "MM-dd-yyyy hh:mm");

      return dt.toFormat("hh:mm a");
    } else {
      return null;
    }
  },
  getJSDateFromDateTime(date, time) {
    const dt = DateTime.fromFormat(`${date} ${time}`, "MM-dd-yyyy hh:mm");
    return dt.toJSDate();
  },
  getJSDateFromDate(date) {
    const dt = DateTime.fromISO(date);
    return dt.toJSDate();
  },
  getDateStringFromJsDate(date) {
    const dt = DateTime.fromISO(date);
    return dt.toFormat("yyyy-MM-dd");
  },
  //  Reduce a raw Stripe token to the shape PaymentInput accepts, so properties
  //  Stripe adds later cannot fail GraphQL validation. Returns null when there
  //  is no token to send.
  sanitizeStripeToken(token) {
    if (!token) {
      return null;
    }
    const payment = pickFields(token, STRIPE_TOKEN_FIELDS);

    if (token.card) {
      const card = pickFields(token.card, STRIPE_CARD_FIELDS);

      //  CardInput.metadata is a String, Stripe sends an object.
      card.metadata = token.card.metadata ? JSON.stringify(token.card.metadata) : null;

      if (token.card.networks) {
        card.networks = pickFields(token.card.networks, STRIPE_CARD_NETWORK_FIELDS);
      }
      payment.card = card;
    } else {
      delete payment.card;
    }

    return payment;
  }
};
